

import React from 'react';
import { Card, CardContent, Collapse, Button, Divider, Box, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { Bar } from 'react-chartjs-2';

/** Displays the collapsible card for each category. */
const CategoryCard = ({ category, categoryData, expanded, handleExpandClick, chartData, index }) => {
  return (
    <Card key={index} elevation={3} sx={{ 
      borderRadius: 2, 
      backgroundColor: categoryData.color, 
      width: '350px', 
      margin: '0 auto' 
    }}>
      <CardContent sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center' 
      }}> 
        <img
          src={categoryData.imageSrc}
          alt={`${category} marker`}
          style={{
            width: '30px',
            height: '30px',
            marginRight: '10px',
          }}
        />
        <Typography variant="h6" fontWeight="bold" fontSize="18px">
          {category}
        </Typography>
        <Button
          onClick={() => handleExpandClick(index)}
          endIcon={
            <ExpandMore sx={{
              transform: expanded === index ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s ease',
            }}/>
          }
        >
          {expanded === index ? 'Collapse' : 'Expand'}
        </Button>
      </CardContent>

      <Collapse in={expanded === index} timeout="auto" unmountOnExit>
        <Divider />
        <CardContent>
          <Box sx={{ height: '300px', mt: 2 }}>
            <Bar 
              data={chartData(category)}  
              options={{ 
                responsive: true, 
                maintainAspectRatio: false 
              }} 
            />
          </Box>
          <Box sx={{ mt: 3 }}>
            {categoryData.items.map((subItem, subIndex) => (
              <Box
                key={subItem.name || `sub-${subIndex}`}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  borderRadius: '3px',
                  px: 1,
                  py: 1
                }}
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  {subItem.name
                    ? subItem.name
                        .split(' ')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ')
                    : 'Unnamed Subcategory'}
                </Typography>
                <Typography>
                  {Array.isArray(subItem.items) ? subItem.items.length : 0}
                </Typography>
              </Box>
            ))}
          </Box>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default CategoryCard;